import React from "react";

import { ReactComponent as ArrowIcon } from "@common/assets/images/arrow-down-right.svg";
import { ReactComponent as PriorityHigh } from "@common/assets/images/priority-high.svg";
import Heading from "@common/components/Heading/Heading";
import { TicketPriority } from "@common/models/TicketPriority.model";
import { TicketStatus } from "@common/models/TicketStatus.model";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { quantity } from "@common/util/strings";
import { TicketListFilters } from "@main/pages/Release/helpers/ticketListLink";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { OpenExternalButton } from "@main/pages/Release/views/MetricCards/shared/OpenExternalButton";
import * as Icon from "@main/pages/shared/icons/icons";

interface FeedbackVolumeCardProps extends ReleaseMetricCardBaseProps {
  totalTickets: number;
  closedTickets: number;
  highPriorityTickets: number;
  highPriorityClosedTickets: number;
  onOpenTickets: (filters: TicketListFilters) => void;
}

const FeedbackVolumeCard = ({
  style,
  totalTickets,
  closedTickets,
  highPriorityClosedTickets,
  highPriorityTickets,
  score,
  highlight,
  error,
  onMoreClick,
  onOpenTickets,
}: FeedbackVolumeCardProps) => {
  return (
    <ReleaseMetricCard
      style={style}
      title={"Feedback volume"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex $column>
        <Flex style={{ alignItems: "center" }}>
          <Heading
            heading2
            marginBottom={0}
          >{`${totalTickets.toString()} ${quantity(totalTickets, "ticket", "tickets")}`}</Heading>
          <OpenExternalButton
            style={{ marginLeft: "0.4rem", marginRight: "1.8rem" }}
            onClick={() => onOpenTickets({})}
          />
          <Icon.StatusDoneIcon />
          <Heading
            heading2
            style={{ marginLeft: "0.6rem", marginBottom: 0, color: vars.colors.greenDarken }}
            marginBottom={0}
          >
            {closedTickets.toString() + " closed"}
          </Heading>
          <OpenExternalButton
            style={{ marginLeft: "0.4rem" }}
            onClick={() => onOpenTickets({ status: TicketStatus.CLOSED })}
          />
        </Flex>
        <Flex style={{ paddingLeft: "0.6rem" }}>
          <ArrowIcon />
          <div style={{ width: "0.6rem" }} />
          <PriorityHigh />
          <Heading
            heading3
            marginBottom={0}
            style={{ marginLeft: "0.6rem" }}
          >{`${highPriorityTickets.toString()} high priority`}</Heading>
          <OpenExternalButton
            style={{ marginLeft: "0.4rem", marginRight: "1.8rem" }}
            onClick={() => onOpenTickets({ priority: TicketPriority.HIGH })}
          />
          <Heading
            heading3
            style={{ color: vars.colors.greenDarken }}
            marginBottom={0}
          >
            {highPriorityClosedTickets.toString() + " closed"}
          </Heading>
          <OpenExternalButton
            style={{ marginLeft: "0.4rem" }}
            onClick={() => onOpenTickets({ priority: TicketPriority.HIGH, status: TicketStatus.CLOSED })}
          />
        </Flex>
      </Flex>
    </ReleaseMetricCard>
  );
};

export { FeedbackVolumeCard };
